import React, { useState } from "react";

export default (props) => {

    if(!props.permitido) return null;

    const [menuOpen, setMenuOpen] = useState(false);
    return (
        <li className={`nav-item has-treeview ${menuOpen ? "menu-open" : ""}`} title={props.title} onClick={() => setMenuOpen(!menuOpen)}>
            <div className="nav-link" style={{ color: "#FFFFFF", cursor:'pointer' }}>
                <i className={`nav-icon ${props.icon}`}></i> <p>{props.label}</p>
            </div>
            <ul className="nav nav-treeview">{props.children}</ul>
        </li>
    );
};
